import { Controller } from "@hotwired/stimulus"

// Mostra a prévia da foto assim que a shopper escolhe da galeria/câmera.
export default class extends Controller {
  static targets = ["input", "preview", "placeholder"]

  show() {
    const file = this.inputTarget.files && this.inputTarget.files[0]
    if (!file) return
    const url = URL.createObjectURL(file)
    this.previewTarget.src = url
    this.previewTarget.classList.remove("hidden")
    if (this.hasPlaceholderTarget) this.placeholderTarget.classList.add("hidden")
  }
}
